import { ReactNode } from 'react';
import { Sheet } from 'react-modal-sheet';

interface BottomSheetProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  headline: string;
  children: ReactNode;
}

const BottomSheet = ({ isOpen, setIsOpen, headline, children }: BottomSheetProps) => {
  return (
    <Sheet isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content>
          <div className="p-4 flex flex-col h-full">
            <h2 className="text-2xl text-center font-semibold">{headline}</h2>
            <div className="mt-4 flex flex-col grow gap-4">{children}</div>
          </div>
        </Sheet.Content>
      </Sheet.Container>
      <Sheet.Backdrop />
    </Sheet>
  );
};

export default BottomSheet;
